import { httpGet } from "./http";

export const rdsMeetingGet = async <T>(url: string): Promise<T> => {
    return httpGet(
        `${globalThis.config.rds_meeting_url}/${url}`,
        [globalThis.config.rds_scope],
        globalThis.config.rds_token_switch ? globalThis.config.rds_token : undefined
    );
}

export const rdsEventGet = async <T>(url: string): Promise<T> => {
    return httpGet(
        `${globalThis.config.rds_event_url}/${url}`,
        [globalThis.config.rds_scope],
        globalThis.config.rds_token_switch ? globalThis.config.rds_token : undefined
    );
}

export const rdsSelectionGet = async <T>(url: string): Promise<T> => {
    return httpGet(
        `${globalThis.config.rds_selection_url}/${url}`,
        [globalThis.config.rds_scope],
        globalThis.config.rds_token_switch ? globalThis.config.rds_token : undefined
    );
}
